@if (disabled) {
  <rc-item-status-badge [itemStatus]="fieldValue"></rc-item-status-badge>
}

@if (!disabled) {
  <ion-select
    [ngClass]="baseCssClass"
    [value]="fieldValue"
    placeholder="Select a value"
    (ionChange)="onInputChange($event)">
    @for (value of itemStatusValues; track value) {
      <ion-select-option [value]="value">{{ itemStatusDisplay[value] }}</ion-select-option>
    }
  </ion-select>
}
